import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VendorRegistrationComponent } from './vendor-registration/vendor-registration.component';
import { RouterModule, Routes } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Ng2SmartTableModule } from 'ng2-smart-table/ng2-smart-table.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { NeoTableLibModule } from 'neo-table-lib';
import { AddRefreshModule } from '../../shared/add-refresh/add-refresh.module';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { NgxPrintModule } from 'ngx-print';
import { DynamicFormModule } from '../../shared/dynamic-form/dynamic-form.module';
import { SharedCrmModule } from '../../shared/shared-crm/shared-crm.module';
import { CommonComponentModule } from '../common-component/common-component.module';
import { VendorAddUpdateComponent } from './vendor-add-update/vendor-add-update.component';
import { CoreModule } from '../../core/core.module';
import { NgbTabsetModule } from '@ng-bootstrap/ng-bootstrap';
import { SalesOrderModule } from '../sales-order/sales-order.module';
import { PartyTypeModule } from '../party-type/party-type.module';
import { PartyWiseSalesLedgerModule } from '../party-wise-sales-ledger/party-wise-sales-ledger.module';
import { CategoryTypeModule } from '../category-type/category-type.module';
import { PartyModule } from '../party/party.module';
import { VendorDetailAddUpdateComponent } from './vendor-detail-add-update/vendor-detail-add-update.component';

const vendorRoutes: Routes = [
  {
    path: 'vendor-registration',
    component: VendorRegistrationComponent,
  },
  {
    path: 'vendor-add-update',
    component: VendorAddUpdateComponent,
  },
  {
    path: 'vendor-add-update/:id',
    component: VendorAddUpdateComponent,
  }
];

@NgModule({
  declarations: [VendorRegistrationComponent, VendorAddUpdateComponent, VendorDetailAddUpdateComponent],
  imports: [
    RouterModule.forChild(vendorRoutes),
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    Ng2SmartTableModule,
    CoreModule,
    NgSelectModule,
    AddRefreshModule,
    DragDropModule,
    NgxDropzoneModule,
    DynamicFormModule,
    NgxPrintModule,
    CommonComponentModule,
    SharedCrmModule,
    NeoTableLibModule,
    NgbTabsetModule,
    SalesOrderModule,
    PartyWiseSalesLedgerModule,
    PartyTypeModule,
    CategoryTypeModule,
  ],

  exports:[VendorDetailAddUpdateComponent]
})
export class VendorRegistrationModule { }